import { render, staticRenderFns } from "./SelectAddressForm.vue?vue&type=template&id=53762e1c&scoped=true&"
import script from "./SelectAddressForm.vue?vue&type=script&lang=js&"
export * from "./SelectAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./SelectAddressForm.vue?vue&type=style&index=0&id=53762e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53762e1c",
  null
  
)

export default component.exports